import { AddBahasaPayload } from "../../../../models/Bahasa";
import { getApiInstance } from "../../../api";
import ApiClient from "../../../apiClient";

import mutationWrapper from "../../mutationWrapper";
import { allBahasaKey } from "../../queries/Bahasa/useFetchAllBahasa";
import getQueryClient from "../../queryClient";

export async function addBahasa(data: AddBahasaPayload) {
  const res = await ApiClient.post(`/AddBahasa`, data);
  return res.data;
}

export const useAddBahasa = mutationWrapper(addBahasa, {
  onSuccess: () => {
    getQueryClient().invalidateQueries(allBahasaKey);
  },
});
